<template>
  <div>
    <h3>
      <Flash fill="var(--red)" :size="16"/>
      {{ heading }}
    </h3>
    <p v-show="hasAtLeastOneVariable">Veuillez sélectionner les options (couleur, taille) des produits offerts :</p>
    <div class="compatible__grid">
      <SkeletonDiv v-show="chainedProducts.length === 0" :width="306" :height="323" v-for="n in 2" :key="n"/>
      <div v-for="(product,i) in chainedProducts" v-if="chainedProducts.length > 0" >
        <ChainedProduct :key="i" :product="product"/>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonDiv from "@/components/skeletons/SkeletonDiv";
import ChainedProduct from "@/front/components/product/ChainedProduct";
import Flash from "@/components/icons/Flash";

export default {
  name: "ChainedProducts",
  components: {Flash, ChainedProduct, SkeletonDiv},
  data() {
    return {
      heading: '',
      chainedProducts: [],
    }
  },
  computed: {
    hasAtLeastOneVariable() {
      return this.chainedProducts.some(product => product.type.includes('variable'))
    },
  },
  beforeMount() {
    this.heading = document.querySelector('.chained__heading h5').innerHTML
    fetch(`/wp-json/g2r/v1/products/chained/${g2rObj.postId}`)
      .then(response => response.json())
      .then(data => this.chainedProducts = data)
  },
}
</script>

<style scoped lang="scss">
h3 {
  background: linear-gradient(to right, var(--red), orange);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
